<template>
  <b-modal
    ref="modal-delete-pengajuan-bahan-packing"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-[32px]"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="text-center gap-2 relative"
    >
      <button
        class="absolute top-0 right-0"
        @click="handleCloseModal"
      >
        <span class="k-close text-[38px] text-[#333]" />
      </button>
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="success"
        width="100"
        height="100"
        class="mx-auto"
      >
      <h3 class="text-[#333] text-[24px] font-semibold my-[20px]">
        Apakah Anda yakin ingin menghapus data ini?
      </h3>
      <p class="text-[#626262] text-[14px] font-normal mb-0">
        Setelah dihapus, data tidak bisa dikembalikan
      </p>
      <b-button
        variant="primary"
        class="w-full mt-[20px] flex items-center justify-center gap-4"
        :disabled="isPending"
        @click="handleDelete"
      >
        <b-spinner
          v-if="isPending"
          small
        />
        {{ isPending ? 'Memproses...' : 'Konfirmasi' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { toastError, toastSuccess } from '@/libs/toastification'

export default {
  name: 'ModalDeleteBahanPacking',
  data() {
    return {
      item: null,
      idPengajuan: null,
      isPending: false,
    }
  },
  created() {
    this.status = null
  },
  methods: {
    show({ item, status }) {
      this.item = item
      this.status = status
      this.idPengajuan = item.id
      this.$refs['modal-delete-pengajuan-bahan-packing'].show()
    },
    handleCloseModal() {
      this.$refs['modal-delete-pengajuan-bahan-packing'].hide()
    },
    /**
     * Handle delete bahan packing
     * note: if status is pengajuan, use delete method
     *       if status is konfirmasi, use post method
     *       submission_type is 3 = Delete Mode
     */
    async handleDelete() {
      this.isPending = true
      const {
        id, name, price, charge_type,
      } = this.item

      const formData = new FormData()
      formData.append('packing_id', id)
      formData.append('submission_type', 3) // 3 = Delete Mode
      formData.append('name', name)
      formData.append('price', price)
      formData.append('charge_type', charge_type)

      try {
        if (this.status === 'pengajuan') {
          await this.$http_new.delete(`/komship/api/v1/packing-material-submissions/${id}`)
        } else {
          await this.$http_new.post('/komship/api/v1/packing-material-submissions', formData)
        }
        toastSuccess('Data berhasil dihapus')
        this.$emit('success')
        this.handleCloseModal()
      } catch (error) {
        toastError('Gagal menghapus data, silahkan coba lagi')
      } finally {
        this.isPending = false
      }
    },
  },
}
</script>
